import { ArrowRight } from 'lucide-react'
import { Link, useLocation } from 'react-router-dom'

export function Header() {
    const location = useLocation()
    const isHomePage = location.pathname === '/'

    const scrollToWaitlist = () => {
        if (isHomePage) {
            const element = document.getElementById('waitlist')
            element?.scrollIntoView({ behavior: 'smooth' })
        } else {
            window.location.href = '/#waitlist'
        }
    }

    return (
        <header className="sticky top-0 z-50 bg-paper/80 backdrop-blur-md border-b border-paper-tertiary">
            <div className="max-w-6xl mx-auto px-8 sm:px-6 lg:px-8">
                <div className="flex items-center justify-between h-16 sm:h-20">
                    {/* Logo */}
                    <Link to="/" className="flex items-center">
                        <img
                            src="/michela-logo-full.png"
                            alt="Michela"
                            className="h-8 sm:h-10"
                        />
                    </Link>

                    {/* CTA Button */}
                    <button
                        onClick={scrollToWaitlist}
                        className="inline-flex items-center gap-2 px-4 py-2.5 sm:px-6 sm:py-3 bg-cta text-white font-semibold text-sm sm:text-base rounded-xl hover:bg-cta-hover transition-colors duration-200 shadow-md hover:shadow-lg"
                    >
                        Join waitlist
                        <ArrowRight className="w-4 h-4" />
                    </button>
                </div>
            </div>
        </header>
    )
}
